import { Rating } from "@smastrom/react-rating";

import { ratingStyles, styles } from "./products-rating.styles";
import { useProductsRating } from "@v2/store/rtk.stamped.selectors";

export default function ProductsRating() {

    const { rating, total } = useProductsRating();


    return (
        <a className={styles} tabIndex={0} href="/reviews" target="_blank">
            {total.toLocaleString()} Reviews
            <Rating
                readOnly
                className="rating"
                itemStyles={ratingStyles}
                value={rating}
            />
        </a>
    )
}